exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media print {\n  .recharts-wrapper, .recharts-surface, .recharts-legend-wrapper {\n    width: 100% !important;\n  }\n  .recharts-legend-item > svg {\n    width: auto !important;\n    display: inline-block !important;\n    right: inherit !important; /* align to left */\n  }\n}\n.BPChart {\n  margin-left: -20px;\n  height: 300px;\n}", ""]);

